/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUrlaubsanspruchDto } from '../../models/create-urlaubsanspruch-dto';

export interface CreateUrlaubsanspruecheForMitarbeiter$Params {

/**
 * ID des Mitarbeiters für den der Urlaubsanspruch erstellt werden soll
 */
  mitarbeiterId: string;
  
    /**
     * Daten für den neuen Urlaubsanspruch
     */
    body?: Array<CreateUrlaubsanspruchDto>
}

export function createUrlaubsanspruecheForMitarbeiter(http: HttpClient, rootUrl: string, params: CreateUrlaubsanspruecheForMitarbeiter$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createUrlaubsanspruecheForMitarbeiter.PATH, 'post');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createUrlaubsanspruecheForMitarbeiter.PATH = '/v1/mitarbeiter/{mitarbeiterId}/urlaubsansprueche';
